export default {
    install(Vue, options) {

        /**
         * 去拿openid
         */
        Vue.prototype.$openid = function () {
            localStorage.return_url = window.location.href;
            this.$router.replace('/welogin');
        }

    }
}